import { EmploymentRequestStatus } from "../AddEmploymentScreen/AddEmploymentScreen";
import { Facility, PendingChangeRequest, WorkingLocation } from "../types";

export type getEmploymentsQuery = {
  currentPerson: {
    employments: Array<{
      id: string;
      title: string;
      isPrimary: boolean;
      startedOn: string;
      facility: Facility;
      description: string;
      workingLocation: WorkingLocation;
    }>;
    pendingChangeRequests?: PendingChangeRequest[];
  };
};

export type UpdateEmploymentMutationResponse = {
  updateEmployment: {
    success: boolean;
    message: string;
    status: EmploymentRequestStatus;
  };
};

export interface UpdateEmploymentMutationVariables {
  input: MembershipUpdateEmploymentInput;
}

export interface MembershipUpdateEmploymentInput {
  employmentId: string;
  jobTitle: string;
  otherJobTitle?: string;
  jobClassification: string;
  jobDescription: string;
  effectiveDate: string;
}

export enum ChangeStatusEnum {
  RETIRED_MEMBER = "RETIRED_MEMBER",
  RESERVE_MEMBER = "RESERVE_MEMBER",
  LIFE_MEMBER_RETIRED = "LIFE_MEMBER_RETIRED",
  LIFE_MEMBER_ACTIVE = "LIFE_MEMBER_ACTIVE",
  LIFE_MEMBER_CENTURY = "LIFE_MEMBER_CENTURY",
}
